import {defineField, defineType} from 'sanity'
import {strongEmLink} from '../../data/richText'
import {PageBlockTypes} from '../pageBlocks'
import getPageInfo, {seoGroup} from '../objects/pageInfo'

export default defineType({
  title: 'Wheel Lines',
  name: 'line',
  type: 'document',
  orderings: [
    {
      title: 'Name A-Z',
      name: 'nameAsc',
      by: [{field: 'name', direction: 'asc'}],
    },
    {
      title: 'Manual Order',
      name: 'manualOrder',
      by: [{field: 'order', direction: 'asc'}],
    },
  ],
  groups: [
    {
      name: 'content',
      title: 'Content',
      default: true,
    },
    {
      name: 'config',
      title: 'Config',
    },
    seoGroup,
  ],
  fields: [
    getPageInfo({path: 'lines'}),
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
      validation: (rule) => rule.required(),
      group: 'content',
    }),
    defineField({
      title: 'Order',
      name: 'order',
      type: 'number',
      group: 'config',
    }),
    defineField({
      name: 'constructionType',
      title: 'Construction Type',
      type: 'reference',
      to: [{type: 'constructionType'}],
      validation: (rule) => rule.required(),
      group: 'content',
    }),
    defineField({
      title: 'Hero',
      name: 'hero',
      type: 'hero',
      group: 'content',
    }),
    defineField({
      title: 'Construction Type',
      name: 'construction',
      type: 'string',
      validation: (rule) => rule.required(),
      options: {
        list: [
          {title: 'Flow Formed', value: 'Flow Formed'},
          {title: 'Forged', value: 'Forged'},
        ],
        layout: 'radio',
      },
      group: 'content',
    }),
    defineField({
      title: 'Line',
      name: 'line',
      type: 'string',
      validation: (rule) => rule.required(),
      group: 'content',
    }),
    defineField({
      title: 'Description',
      name: 'description',
      type: 'array',
      of: strongEmLink,
      validation: (rule) => rule.required(),
      group: 'content',
      description: 'This text will be used in blocks as short description',
    }),
    defineField({
      name: 'about',
      title: 'About',
      type: 'richText',
      group: 'content',
      description: 'This text will appear at the top of the page',
    }),
    defineField({
      title: 'Presentational image (desktop)',
      name: 'imageDesktop',
      type: 'image',
      description: 'Used on product listing (All Wheels)',
      options: {
        hotspot: true,
      },
      group: 'content',
    }),
    defineField({
      title: 'Presentational image (mobile)',
      name: 'imageMobile',
      type: 'image',
      description: 'Used on product listing (All Wheels)',
      options: {
        hotspot: true,
      },
      group: 'content',
    }),
    defineField({
      title: 'Thumb image',
      name: 'imageThumb',
      type: 'image',
      description: 'Used on wheel line listing component',
      options: {
        hotspot: true,
      },
      group: 'content',
    }),
    defineField({
      title: 'Wheel Designs',
      name: 'designs',
      type: 'array',
      of: [
        {
          type: 'reference',
          to: [{type: 'design'}],
        },
      ],
      group: 'content',
    }),
    defineField({
      title: 'Page blocks',
      name: 'pageBlocks',
      type: 'array',
      of: PageBlockTypes,
      group: 'content',
    }),
  ],
  preview: {
    select: {
      title: 'title',
    },
    prepare({title = 'Untitled'}) {
      return {
        title,
        subtitle: 'Wheel line',
      }
    },
  },
})
